require([
    "common/alertMessage",
    "common/formUtils",
    "common/spinner",
    "common/matomoHelper"
],
    function (alertMessage, formUtils, spinner, matomoHelper) {

        const formId = "#training-resource-form";
        const contactFormId = "#shipping-contact-form";
        const contactDropdownSelector = "#shipping-contact-id";
        const shippingFormId = "#shipping-address-form";
        const addressDropdownSelector = "#shipping-account-id";
        const shippingToBusinessFormRowSelector = "#shipping-to-business-or-not-row";
        const shippingToBusinessInputSelector = "#shipping-address-form input[name=ShippingToBusiness]";
        const companyNameRowSelector = "#shipping-company-name-row";
        const companyNameInputSelector = "#shipping-company-name";
        const submitButtonSelector = "#submit-button";
        const submitMessageSelector = "#submit-message";
        const spinnerSelector = "#training-resource-form-spinner";
        const reCaptchaV2Selector = "#recaptcha-v2";
        var reCaptchaV2WidgetId = undefined;

        function init() {
            $(addressDropdownSelector).off("change").on("change", addressDropdownChanged);
            $(contactDropdownSelector).off("change").on("change", contactDropdownChanged);
            $(shippingToBusinessInputSelector).off("change").on("change", shippingToBusinessChanged);
            $(submitButtonSelector).off("click").on("click", submitButton);

            addressDropdownChanged();
        }

        function addressDropdownChanged(event) {
            var dropdownValue = $(addressDropdownSelector).val();

            if (dropdownValue === ADDRESS_ID.ShippingNewValue) {
                formUtils.enableFields(shippingFormId);
                formUtils.populateFormWithData(shippingFormId, {});
                $(shippingToBusinessFormRowSelector).show();
                refreshContactDropdown(ADDRESS_ID.ShippingNewValue);
            }
            else {
                var addressData = ShippingAddresses.find(function (address) {
                    return address.ShippingAccountId === dropdownValue;
                });
                if (addressData) {
                    formUtils.populateFormWithData(shippingFormId, addressData);
                }
                formUtils.disableFields(shippingFormId);
                $(shippingToBusinessFormRowSelector).hide();
                refreshContactDropdown(addressData ? addressData.ShippingAccountId : null);
            }

            shippingToBusinessChanged();
            formUtils.initializeFloatingLabels(shippingFormId);
        }

        function refreshContactDropdown(accountId) {
            $(contactDropdownSelector + " option:not([value='" + ADDRESS_ID.ContactNewValue + "'])").remove();

            if (accountId === ADDRESS_ID.ShippingNewValue) {
                var loggedInContact = ShippingContacts.find(function (c) { return c.IsDefault; });
                if (loggedInContact) {
                    $(contactDropdownSelector).prepend(
                        `<option value="${loggedInContact.ShippingContactId}">${loggedInContact.ShippingFirstName || ''} ${loggedInContact.ShippingLastName || ''}, ${loggedInContact.ShippingPhoneNumber || ''}</option>`
                    );
                }
                $(contactDropdownSelector).val(ADDRESS_ID.ContactNewValue);
                contactDropdownChanged();
                return;
            }

            var selectContactValue = ADDRESS_ID.ContactNewValue;
            if (accountId) {
                var contacts = Array.from(ShippingContacts).filter(function (c) { return c.ShippingAccountId === accountId; });
                if (contacts.length) {
                    contacts.sort(function (a, b) {
                        var fullNameA = a.ShippingFirstName + ' ' + a.ShippingLastName;
                        var fullNameB = b.ShippingFirstName + ' ' + b.ShippingLastName;
                        if (fullNameA < fullNameB) return -1;
                        if (fullNameA > fullNameB) return 1;
                        return 0;
                    });
                    var defaultContact = contacts.find(function (c) { return c.IsDefault; }) || contacts[0];
                    selectContactValue = defaultContact.ShippingContactId;
                    contacts.reverse();
                    contacts.forEach(function (c) {
                        $(contactDropdownSelector).prepend(
                            `<option value="${c.ShippingContactId}">${c.ShippingFirstName || ''} ${c.ShippingLastName || ''}, ${c.ShippingPhoneNumber || ''}</option>`
                        );
                    });
                }
            }

            $(contactDropdownSelector).val(selectContactValue);
            contactDropdownChanged();
        }

        function contactDropdownChanged(event) {
            var dropdownValue = $(contactDropdownSelector).val();

            if (dropdownValue === ADDRESS_ID.ContactNewValue) {
                formUtils.enableFields(contactFormId);
                formUtils.populateFormWithData(contactFormId, {});
            }
            else {
                var contactData = ShippingContacts.find(function (contact) {
                    return contact.ShippingContactId === dropdownValue;
                });
                if (contactData) {
                    formUtils.populateFormWithData(contactFormId, contactData);
                }
                disableFieldsWithData(contactFormId);
            }

            formUtils.initializeFloatingLabels(contactFormId);
        }

        function disableFieldsWithData(formId) {
            $(formId + " :input").each(function (index, element) {
                var value = $(element).val();
                $(element).prop("disabled", value !== null && value !== "");
            });
        }

        function shippingToBusinessChanged(event) {
            if ($(shippingToBusinessInputSelector + ":checked").val() === "true") {
                $(companyNameRowSelector).show();
            } else {
                $(companyNameRowSelector).hide();
                $(companyNameInputSelector).val("");
            }
        }

        function submitButton(event) {
            event.preventDefault();
            matomoHelper.trackFormSubmit(formId);
            spinner.show(spinnerSelector);
            try {
                var siteKey = $(formId).data("grecaptchaSiteKeyV3");
                grecaptcha.ready(function () {
                    try {
                        grecaptcha.execute(siteKey, { action: "training_resource" })
                            .then(function (token) {
                                sendDataToBackEnd(token, "v3");
                            })
                            .catch(function (e) {
                                sendDataToBackEnd(null, "v3", "Google reCaptcha error in TrainingResourceForm.js, grecaptcha.execute call: " + e);
                            });
                    } catch (e) {
                        sendDataToBackEnd(null, "v3", "Google reCaptcha error in TrainingResourceForm.js, grecaptcha.ready call: " + (e.stack || e.message));
                    }
                });
            } catch (e) {
                sendDataToBackEnd(null, "v3", "Google reCaptcha error in TrainingResourceForm.js, submitButton: " + (e.stack || e.message));
            }
        }

        function sendDataToBackEnd(googleReCaptchaToken, reCaptchaVersion, reCaptchaErrorMessage) {
            var formData = formUtils.collectFormData(formId);
            if (reCaptchaVersion === "v3") formData.GoogleReCaptchaV3Token = googleReCaptchaToken;
            if (reCaptchaVersion === "v2") formData.GoogleReCaptchaV2Token = googleReCaptchaToken;
            formData.GoogleReCaptchaErrorMessage = reCaptchaErrorMessage;
            formUtils.useToken(formData);
            formUtils.clearInvalidFeedback(formId);

            $.ajax({
                type: "POST",
                url: "/customapi/Order/TrainingResourceRequestCatalog",
                dataType: "json",
                data: formData,
                success: function (data) {
                    if (data.status === "OK") {
                        matomoHelper.trackFormConversion(formId);
                        $("#ordering-form").remove();
                        $("#literatureSubmitted").show();
                    } else {
                        handleErrorStatus(data);
                        spinner.hide(spinnerSelector);
                    }
                },
                error: function (jq, status, errorThrown) {
                    alertMessage.error(status + ". " + errorThrown);
                    spinner.hide(spinnerSelector);
                }
            });
        }

        function handleErrorStatus(data) {
            if (data.displayReCaptchaV2) {
                displayReCaptchaV2();
            }
            else {
                $(submitButtonSelector).show();
                $(reCaptchaV2Selector).hide();
            }
            if (data.message) $(submitMessageSelector).html(data.message);
            formUtils.displayInvalidFeedback(data.invalidFormFields, formId);
        }

        function displayReCaptchaV2() {
            $(submitButtonSelector).hide();
            $(reCaptchaV2Selector).show();
            if (reCaptchaV2WidgetId !== undefined) {
                grecaptcha.reset(reCaptchaV2WidgetId);
            }
            else {
                var siteKey = $(formId).data("grecaptchaSiteKeyV2");
                grecaptcha.ready(function () {
                    reCaptchaV2WidgetId = grecaptcha.render($(reCaptchaV2Selector)[0], {
                        'sitekey': siteKey,
                        callback: function (token) {
                            spinner.show(spinnerSelector);
                            sendDataToBackEnd(token, "v2");
                        }
                    });
                });
            }
        }

        init();
    });

define("TrainingResourceForm/main", function(){});

